import axios from 'axios'

const state = {
  personalTopics: null,
  userPersonalTopics: null,
  displayConfirmation: false
}

const actions = {
  fetchUserPersonalTopics: async ({commit}, params) => {
    commit('SET_DISPLAY_CONFIRMATION', false)
    const url = '/user-personal-topics'
    const res = await axios.get(url, {params})
    if (res.status === 200) {
      const response = res.data
      commit('SET_DATA', response)
    }
  }
}

const mutations = {
  SET_DATA: (state, response) => {
    state.personalTopics = response.personal_topics
    state.userPersonalTopics = response.user_personal_topics
    state.displayConfirmation = response.display_confirmation
  },
  SET_DISPLAY_CONFIRMATION: (state, status) => {
    state.displayConfirmation = status
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.personal.topic.js